import domReady from '../utils/domReady';

const trigger = () => {

  domReady(() => {
    // Get all "trigger" elements
    const scrollTrigger = document.querySelector('.u-scroll-trigger');
    const $trigger = Array.prototype.slice.call(
      document.querySelectorAll('.u-trigger'),
      0,
    );

    const moveToMainContent = () => {
      const mainContentTop = document.getElementById('content').getBoundingClientRect().top;
      const headerHeight = document.querySelector('.c-header').getBoundingClientRect().height;
      window.scrollTo({
        top: mainContentTop - headerHeight, // scroll so that the element is at the top of the view
        behavior: 'smooth', // smooth scroll
      })
    }

    // Check if there are any navbar burgers
    if ($trigger.length > 0) {
      // Add a click event on each of them
      $trigger.forEach(el => {
        el.addEventListener('click', () => {
          // Get the target from the "data-target" attribute
          const { target } = el.dataset;
          const targetArr = target.split(',');

          targetArr.forEach(t => {
            const $target = document.getElementById(t);

            $target.classList.toggle('is-active');

            if (t === 'searchBar') {
              $target.querySelector('input').focus();
            }
          })

          // Toggle the "is-active" class on both the "c-nav__burger" and the "c-nav__menu"
          el.classList.toggle('is-active');
        });
      });
    }

    if (scrollTrigger) {
      scrollTrigger.addEventListener('click', moveToMainContent)
    }
  })
}

trigger();
